function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { fieldIntersection, hash, hasIntersection, isEmpty, keys, some } from '../../util';
import { requiresSelectionId } from '../selection';
import { AggregateNode } from './aggregate';
import { BinNode } from './bin';
import { OutputNode } from './dataflow';
import { FacetNode } from './facet';
import { FilterNode } from './filter';
import { ParseNode } from './formatparse';
import { IdentifierNode } from './identifier';
import { BottomUpOptimizer, isDataSourceNode, Optimizer, TopDownOptimizer } from './optimizer';
import { SourceNode } from './source';
import { TimeUnitNode } from './timeunit';
/**
 * Merge identical nodes at forks by comparing hashes.
 *
 * Does not need to iterate from leaves so we implement this with recursion as it's a bit simpler.
 */
export var MergeIdenticalNodes = /*#__PURE__*/function (_TopDownOptimizer) {
  function MergeIdenticalNodes() {
    _classCallCheck(this, MergeIdenticalNodes);
    return _callSuper(this, MergeIdenticalNodes, arguments);
  }
  _inherits(MergeIdenticalNodes, _TopDownOptimizer);
  return _createClass(MergeIdenticalNodes, [{
    key: "mergeNodes",
    value: function mergeNodes(parent, nodes) {
      var mergedNode = nodes.shift();
      var _iterator = _createForOfIteratorHelper(nodes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          parent.removeChild(node);
          node.parent = mergedNode;
          node.remove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "run",
    value: function run(node) {
      var hashes = node.children.map(function (x) {
        return x.hash();
      });
      var buckets = {};
      for (var i = 0; i < hashes.length; i++) {
        if (buckets[hashes[i]] === undefined) {
          buckets[hashes[i]] = [node.children[i]];
        } else {
          buckets[hashes[i]].push(node.children[i]);
        }
      }
      var _iterator2 = _createForOfIteratorHelper(keys(buckets)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var k = _step2.value;
          if (buckets[k].length > 1) {
            this.setModified();
            this.mergeNodes(node, buckets[k]);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);
}(TopDownOptimizer);
/**
 * Optimizer that removes identifier nodes that are not needed for selections.
 */
export var RemoveUnnecessaryIdentifierNodes = /*#__PURE__*/function (_TopDownOptimizer2) {
  function RemoveUnnecessaryIdentifierNodes(model) {
    var _this;
    _classCallCheck(this, RemoveUnnecessaryIdentifierNodes);
    _this = _callSuper(this, RemoveUnnecessaryIdentifierNodes);
    _this.requiresSelectionId = model && requiresSelectionId(model);
    return _this;
  }
  _inherits(RemoveUnnecessaryIdentifierNodes, _TopDownOptimizer2);
  return _createClass(RemoveUnnecessaryIdentifierNodes, [{
    key: "run",
    value: function run(node) {
      if (node instanceof IdentifierNode) {
        // Only preserve IdentifierNodes if we have default discrete selections
        // in our model tree, and if the nodes come after tuple producing nodes.
        if (!(this.requiresSelectionId && (isDataSourceNode(node.parent) || node.parent instanceof AggregateNode || node.parent instanceof ParseNode))) {
          this.setModified();
          node.remove();
        }
      }
    }
  }]);
}(TopDownOptimizer);
/**
 * Removes duplicate time unit nodes (as determined by the name of the output field) that may be generated due to
 * selections projected over time units. Only keeps the first time unit in any branch.
 *
 * This optimizer is a custom top down optimizer that keep track of produced fields in a branch.
 */
export var RemoveDuplicateTimeUnits = /*#__PURE__*/function (_Optimizer) {
  function RemoveDuplicateTimeUnits() {
    _classCallCheck(this, RemoveDuplicateTimeUnits);
    return _callSuper(this, RemoveDuplicateTimeUnits, arguments);
  }
  _inherits(RemoveDuplicateTimeUnits, _Optimizer);
  return _createClass(RemoveDuplicateTimeUnits, [{
    key: "optimize",
    value: function optimize(node) {
      this.run(node, new Set());
      return this.modifiedFlag;
    }
  }, {
    key: "run",
    value: function run(node, timeUnitFields) {
      var producedFields = new Set();
      if (node instanceof TimeUnitNode) {
        producedFields = node.producedFields();
        if (hasIntersection(producedFields, timeUnitFields)) {
          this.setModified();
          node.removeFormulas(timeUnitFields);
          if (node.producedFields.length === 0) {
            node.remove();
          }
        }
      }
      var _iterator3 = _createForOfIteratorHelper(node.children),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          this.run(child, new Set([].concat(_toConsumableArray(timeUnitFields), _toConsumableArray(producedFields))));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);
}(Optimizer);
/**
 * Remove output nodes that are not required.
 */
export var RemoveUnnecessaryOutputNodes = /*#__PURE__*/function (_TopDownOptimizer3) {
  function RemoveUnnecessaryOutputNodes() {
    _classCallCheck(this, RemoveUnnecessaryOutputNodes);
    return _callSuper(this, RemoveUnnecessaryOutputNodes);
  }
  _inherits(RemoveUnnecessaryOutputNodes, _TopDownOptimizer3);
  return _createClass(RemoveUnnecessaryOutputNodes, [{
    key: "run",
    value: function run(node) {
      if (node instanceof OutputNode && !node.isRequired()) {
        this.setModified();
        node.remove();
      }
    }
  }]);
}(TopDownOptimizer);
/**
 * Move parse nodes up to forks and merges them if possible.
 */
export var MoveParseUp = /*#__PURE__*/function (_BottomUpOptimizer) {
  function MoveParseUp() {
    _classCallCheck(this, MoveParseUp);
    return _callSuper(this, MoveParseUp, arguments);
  }
  _inherits(MoveParseUp, _BottomUpOptimizer);
  return _createClass(MoveParseUp, [{
    key: "run",
    value: function run(node) {
      if (isDataSourceNode(node)) {
        return;
      }
      if (node.numChildren() > 1) {
        // Don't move parse further up but continue with parent.
        return;
      }
      var _iterator4 = _createForOfIteratorHelper(node.children),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;
          if (child instanceof ParseNode) {
            if (node instanceof ParseNode) {
              this.setModified();
              node.merge(child);
            } else {
              // Don't swap with nodes that produce something that the parse node depends on (e.g. lookup).
              if (fieldIntersection(node.producedFields(), child.dependentFields())) {
                continue;
              }
              this.setModified();
              child.swapWithParent();
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return;
    }
  }]);
}(BottomUpOptimizer);
/**
 * Inserts an intermediate ParseNode containing all non-conflicting parse fields and removes the empty ParseNodes.
 *
 * We assume that dependent paths that do not have a parse node can be just merged.
 */
export var MergeParse = /*#__PURE__*/function (_BottomUpOptimizer2) {
  function MergeParse() {
    _classCallCheck(this, MergeParse);
    return _callSuper(this, MergeParse, arguments);
  }
  _inherits(MergeParse, _BottomUpOptimizer2);
  return _createClass(MergeParse, [{
    key: "run",
    value: function run(node) {
      var originalChildren = _toConsumableArray(node.children);
      var parseChildren = node.children.filter(function (child) {
        return child instanceof ParseNode;
      });
      if (node.numChildren() > 1 && parseChildren.length >= 1) {
        var commonParse = {};
        var conflictingParse = new Set();
        var _iterator5 = _createForOfIteratorHelper(parseChildren),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var parseNode = _step5.value;
            var parse = parseNode.parse;
            var _iterator9 = _createForOfIteratorHelper(keys(parse)),
              _step9;
            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var k = _step9.value;
                if (!(k in commonParse)) {
                  commonParse[k] = parse[k];
                } else if (commonParse[k] !== parse[k]) {
                  conflictingParse.add(k);
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        var _iterator6 = _createForOfIteratorHelper(conflictingParse),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var field = _step6.value;
            delete commonParse[field];
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        if (!isEmpty(commonParse)) {
          this.setModified();
          var mergedParseNode = new ParseNode(node, commonParse);
          var _iterator7 = _createForOfIteratorHelper(originalChildren),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var childNode = _step7.value;
              if (childNode instanceof ParseNode) {
                var _iterator8 = _createForOfIteratorHelper(keys(commonParse)),
                  _step8;
                try {
                  for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                    var key = _step8.value;
                    delete childNode.parse[key];
                  }
                } catch (err) {
                  _iterator8.e(err);
                } finally {
                  _iterator8.f();
                }
              }
              node.removeChild(childNode);
              childNode.parent = mergedParseNode;
              // remove empty parse nodes
              if (childNode instanceof ParseNode && keys(childNode.parse).length === 0) {
                childNode.remove();
              }
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
      }
    }
  }]);
}(BottomUpOptimizer);
/**
 * Repeatedly remove leaf nodes that are not output or facet nodes.
 * The reason is that we don't need subtrees that don't have any output nodes.
 * Facet nodes are needed for the row or column domains.
 */
export var RemoveUnusedSubtrees = /*#__PURE__*/function (_BottomUpOptimizer3) {
  function RemoveUnusedSubtrees() {
    _classCallCheck(this, RemoveUnusedSubtrees);
    return _callSuper(this, RemoveUnusedSubtrees, arguments);
  }
  _inherits(RemoveUnusedSubtrees, _BottomUpOptimizer3);
  return _createClass(RemoveUnusedSubtrees, [{
    key: "run",
    value: function run(node) {
      if (node instanceof OutputNode || node.numChildren() > 0 || node instanceof FacetNode) {
        // no need to continue with parent because it is output node or will have children (there was a fork)
      } else if (node instanceof SourceNode) {
        // ignore empty unused sources as they will be removed in optimizationDataflowHelper
      } else {
        this.setModified();
        node.remove();
      }
    }
  }]);
}(BottomUpOptimizer);
/**
 * Merge adjacent time unit nodes.
 */
export var MergeTimeUnits = /*#__PURE__*/function (_BottomUpOptimizer4) {
  function MergeTimeUnits() {
    _classCallCheck(this, MergeTimeUnits);
    return _callSuper(this, MergeTimeUnits, arguments);
  }
  _inherits(MergeTimeUnits, _BottomUpOptimizer4);
  return _createClass(MergeTimeUnits, [{
    key: "run",
    value: function run(node) {
      var timeUnitChildren = node.children.filter(function (x) {
        return x instanceof TimeUnitNode;
      });
      var combination = timeUnitChildren.pop();
      var _iterator10 = _createForOfIteratorHelper(timeUnitChildren),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var timeUnit = _step10.value;
          this.setModified();
          combination.merge(timeUnit);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }]);
}(BottomUpOptimizer);
export var MergeAggregates = /*#__PURE__*/function (_BottomUpOptimizer5) {
  function MergeAggregates() {
    _classCallCheck(this, MergeAggregates);
    return _callSuper(this, MergeAggregates, arguments);
  }
  _inherits(MergeAggregates, _BottomUpOptimizer5);
  return _createClass(MergeAggregates, [{
    key: "run",
    value: function run(node) {
      var aggChildren = node.children.filter(function (child) {
        return child instanceof AggregateNode;
      });
      // Object which we'll use to map the fields which an aggregate is grouped by to
      // the set of aggregates with that grouping. This is useful as only aggregates
      // with the same group by can be merged
      var groupedAggregates = {};
      // Build groupedAggregates
      var _iterator11 = _createForOfIteratorHelper(aggChildren),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var agg = _step11.value;
          var groupBys = hash(agg.groupBy);
          if (!(groupBys in groupedAggregates)) {
            groupedAggregates[groupBys] = [];
          }
          groupedAggregates[groupBys].push(agg);
        }
        // Merge aggregateNodes with same key in groupedAggregates
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      var _iterator12 = _createForOfIteratorHelper(keys(groupedAggregates)),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var group = _step12.value;
          var mergeableAggs = groupedAggregates[group];
          if (mergeableAggs.length > 1) {
            var mergedAggs = mergeableAggs.pop();
            var _iterator13 = _createForOfIteratorHelper(mergeableAggs),
              _step13;
            try {
              for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                var _agg = _step13.value;
                if (mergedAggs.merge(_agg)) {
                  node.removeChild(_agg);
                  _agg.parent = mergedAggs;
                  _agg.remove();
                  this.setModified();
                }
              }
            } catch (err) {
              _iterator13.e(err);
            } finally {
              _iterator13.f();
            }
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }
  }]);
}(BottomUpOptimizer);
/**
 * Merge bin nodes and move them up through forks. Stop at filters, parse, identifier as we want them to stay before the bin node.
 */
export var MergeBins = /*#__PURE__*/function (_BottomUpOptimizer6) {
  function MergeBins(model) {
    var _this2;
    _classCallCheck(this, MergeBins);
    _this2 = _callSuper(this, MergeBins);
    _this2.model = model;
    return _this2;
  }
  _inherits(MergeBins, _BottomUpOptimizer6);
  return _createClass(MergeBins, [{
    key: "run",
    value: function run(node) {
      var moveBinsUp = !(isDataSourceNode(node) || node instanceof FilterNode || node instanceof ParseNode || node instanceof IdentifierNode);
      var promotableBins = [];
      var remainingBins = [];
      var _iterator14 = _createForOfIteratorHelper(node.children),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var child = _step14.value;
          if (child instanceof BinNode) {
            if (moveBinsUp && !fieldIntersection(node.producedFields(), child.dependentFields())) {
              promotableBins.push(child);
            } else {
              remainingBins.push(child);
            }
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      if (promotableBins.length > 0) {
        var promotedBin = promotableBins.pop();
        var _iterator15 = _createForOfIteratorHelper(promotableBins),
          _step15;
        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var bin = _step15.value;
            promotedBin.merge(bin, this.model.renameSignal.bind(this.model));
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }
        this.setModified();
        if (node instanceof BinNode) {
          node.merge(promotedBin, this.model.renameSignal.bind(this.model));
        } else {
          promotedBin.swapWithParent();
        }
      }
      if (remainingBins.length > 1) {
        var remainingBin = remainingBins.pop();
        var _iterator16 = _createForOfIteratorHelper(remainingBins),
          _step16;
        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var _bin = _step16.value;
            remainingBin.merge(_bin, this.model.renameSignal.bind(this.model));
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
        this.setModified();
      }
    }
  }]);
}(BottomUpOptimizer);
/**
 * This optimizer takes output nodes that are at a fork and moves them before the fork.
 *
 * The algorithm iterates over the children and tries to find the last output node in a chain of output nodes.
 * It then moves all output nodes before that main output node. All other children (and the children of the output nodes)
 * are inserted after the main output node.
 */
export var MergeOutputs = /*#__PURE__*/function (_BottomUpOptimizer7) {
  function MergeOutputs() {
    _classCallCheck(this, MergeOutputs);
    return _callSuper(this, MergeOutputs, arguments);
  }
  _inherits(MergeOutputs, _BottomUpOptimizer7);
  return _createClass(MergeOutputs, [{
    key: "run",
    value: function run(node) {
      var children = _toConsumableArray(node.children);
      var hasOutputChild = some(children, function (child) {
        return child instanceof OutputNode;
      });
      if (!hasOutputChild || node.numChildren() <= 1) {
        return;
      }
      var otherChildren = [];
      // The output node we will connect all other nodes to.
      // Output nodes will be added before the new node, other nodes after.
      var mainOutput;
      var _iterator17 = _createForOfIteratorHelper(children),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _child = _step17.value;
          if (_child instanceof OutputNode) {
            var lastOutput = _child;
            while (lastOutput.numChildren() === 1) {
              var _lastOutput$children = _slicedToArray(lastOutput.children, 1),
                theChild = _lastOutput$children[0];
              if (theChild instanceof OutputNode) {
                lastOutput = theChild;
              } else {
                break;
              }
            }
            otherChildren.push.apply(otherChildren, _toConsumableArray(lastOutput.children));
            if (mainOutput) {
              // Move the output nodes before the mainOutput. We do this by setting
              // the parent of the first not to the parent of the main output and
              // the main output's parent to the last output.
              // note: the child is the first output
              node.removeChild(_child);
              _child.parent = mainOutput.parent;
              mainOutput.parent.removeChild(mainOutput);
              mainOutput.parent = lastOutput;
              this.setModified();
            } else {
              mainOutput = lastOutput;
            }
          } else {
            otherChildren.push(_child);
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
      if (otherChildren.length) {
        this.setModified();
        var _iterator18 = _createForOfIteratorHelper(otherChildren),
          _step18;
        try {
          for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
            var child = _step18.value;
            child.parent.removeChild(child);
            child.parent = mainOutput;
          }
        } catch (err) {
          _iterator18.e(err);
        } finally {
          _iterator18.f();
        }
      }
    }
  }]);
}(BottomUpOptimizer);